import React from 'react';
import LoadingSpinner from '../../LoadingSpinner';
import "react-table/react-table.css";
import 'bootstrap/dist/css/bootstrap.css';
import ReactTooltip from "react-tooltip";
import NPReactTable from '../../NPReactTable';
import Dialog from 'react-bootstrap-dialog';

class AllocationOnlyOrders extends React.Component {
    constructor(props) {
        super(props);
        this.state={
          header: this.props.apiToken ? {
              'Authorization': 'Bearer ' +  this.props.apiToken,
              'Accept': 'application/octet-stream'
          } : {},
          detailsGroups: this.props.data ? this.props.data : [], 
          expanded: {}, 
          page: 0,
          pageSize: 10, 
          resized: [],
          isLoading: false,
        };
        this.getColumns=this.getColumns.bind(this);
      }     

  //     componentWillReceiveProps(nextProps) {
  //       if (nextProps.ccr !== this.props.ccr) {
  //          this.setState({ page: 0 });
  //      };
  //  }

  handleCustomerLink(viewMode){
    let returnObject = viewMode;
      if(viewMode != null && viewMode.includes("Customer")){
      let customerParts = viewMode.split(' ');
      let customerId = customerParts[customerParts.indexOf("Customer:")+1].replace(',','');
      if(customerId != null ||customerId != ''){
        returnObject = (<a href={'./customerprofile'} onClick={() => window.sessionStorage.setItem("customerId",customerId)}>{viewMode}</a>);
      }
    }
    return returnObject;
}

    getColumns() {    
        return [          
          {            
            columns: [
              {
                minWidth: 140,
                maxWidth: 320,
                id:'ViewModes',
                className:'ViewModes',
                Cell: row => (
                  <div>
                    <span className="ViewModes">
                      {this.handleCustomerLink(row.original.ViewModes)}
                      {/* {row.original.ViewModes || ''} */}
                    </span>
                  </div>
                )
              },
            ]
          },
          {
            columns: [
              {
                Header: "Jan",
                maxWidth: 90,
                accessor:'GuiM1_UC'
              },
              {
                Header: "Feb",
                maxWidth:90,
                accessor:'GuiM2_UC'
              },
              {
                Header: "Mar",
                maxWidth:90,
                accessor:'GuiM3_UC'
              },
              {
                Header: "Apr",
                maxWidth:90,
                accessor:'GuiM4_UC'
              },
              {
                Header: "May",
                maxWidth:90,
                accessor:'GuiM5_UC'
              },
              {
                Header: "Jun",
                maxWidth:90,
                accessor:'GuiM6_UC'
              },
              {
                Header: "Jul",
                maxWidth:90,
                accessor:'GuiM7_UC'
              },
              {
                Header: "Aug",
                maxWidth:90,
                accessor:'GuiM8_UC'
              },
              {
                Header: "Sep",
                maxWidth:90,
                accessor:'GuiM9_UC'
              },
              {
                Header: "Oct",
                maxWidth:90,
                accessor:'GuiM10_UC'
              },
              {
                Header: "Nov",
                maxWidth:90,
                accessor:'GuiM11_UC'
              },
              {
                Header: "Dec",
                maxWidth:90,
                accessor:'GuiM12_UC'
              },
              {
                Header: "Total",
                minWidth:110,
                accessor:'GuiTotal_UC'
              },
            ]
          }
        ];
      }

    getTable(data){
      if (this.state.isLoading)
      {
        return (
            <LoadingSpinner isLoading={true} />
        );
      }
    else 
    {
        return(
            <div>
              <div>
                  <NPReactTable
                  className="margin-top-5 np-react-table onlyOrders"
                  data={data}
                  ref={(r) => { this.reactTable = r }}
                  // showPagination={false}
                  // showPageSizeOptions={false}
                  sortable={false}
                  hasHeaderGroups={false}
                  // minRows={3} 
                  columns={this.getColumns()}
                  defaultPageSize={10}
                  // Controlled props
                  sorted={this.state.sorted}
                  page={this.state.page}
                  pageSize={this.state.pageSize}
                  expanded={this.state.expanded}
                  resized={this.state.resized}  
                  onResizedChange={resized => { this.setState({ resized }) } }
                  onPageChange={
                    page => {
                      this.setState({ page });
                    }
                  }
                  onPageSizeChange={(pageSize, page) => {
                      this.setState({ page, pageSize });
                    }
                  }
                />
              </div>
            </div>
          )
        }
    }

    render()
    {
        const data = this.state.detailsGroups ? this.state.detailsGroups : [];

        return ( 
            <div>  
                {this.getTable(data)}
            </div>
        );
    }
}

export default AllocationOnlyOrders;